/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Hero_Cta_OnlineInputs */

const en_fc_home_hero_cta_online = /** @type {(inputs: Fc_Home_Hero_Cta_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore online editing`)
};

/**
* | output |
* | --- |
* | "Explore online editing" |
*
* @param {Fc_Home_Hero_Cta_OnlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_hero_cta_online = /** @type {((inputs?: Fc_Home_Hero_Cta_OnlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Hero_Cta_OnlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_hero_cta_online(inputs)
});
export { fc_home_hero_cta_online as "fc.home.hero.cta_online" }